var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var FutureIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 81,
    glyphHeight: 56,
    glyphOffsetY: 15
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4948 55.3279C41.1609 55.336 40.8261 55.3401 40.4903 55.3401C40.1408 55.3401 39.7923 55.3357 39.4448 55.3269V11.8813L30.0935 53.9927C29.4272 53.8162 28.7677 53.6231 28.1154 53.4139L37.2104 12.5168H37.1899L20.6421 50.1493C20.041 49.8105 19.4495 49.4569 18.8679 49.0888L35.058 12.3118L13.0341 44.608C12.5285 44.1412 12.0348 43.6617 11.5535 43.17L33.4356 11.0642L6.95525 37.5445C6.56148 36.9637 6.18241 36.3721 5.81856 35.7703L31.491 10.0978L2.96224 30.074C2.69501 29.4158 2.4446 28.749 2.21154 28.074L28.5596 9.62634C18.4449 11.5002 8.86496 15.7307 0.637239 22.0259C0.221091 19.6981 0.00390625 17.3012 0.00390625 14.8537C0.00390625 14.0262 0.0287306 13.2046 0.0776735 12.3894C12.0229 4.58584 26.057 0.340088 40.4698 0.340088C54.8998 0.340088 68.9501 4.59596 80.9046 12.4173C80.9524 13.2233 80.9767 14.0357 80.9767 14.8537C80.9767 17.3122 80.7576 19.7195 80.3378 22.0571C72.1258 15.756 62.5209 11.5217 52.4005 9.64683V9.66733L78.7536 28.1186C78.5236 28.7821 78.2769 29.4379 78.0138 30.0852L49.4691 10.0978L75.1543 35.7831C74.7903 36.3847 74.411 36.9761 74.0171 37.5568L47.5245 11.0642L69.415 43.1823C68.9296 43.6779 68.4315 44.161 67.9214 44.6312L45.8817 12.3118L62.0806 49.1091C61.4935 49.4799 60.8962 49.8361 60.2892 50.177L43.7292 12.5168H43.7087L52.8078 53.4323C52.1616 53.6385 51.5083 53.8288 50.8484 54.003L41.4948 11.8813V55.3279Z",
    fill: "black"
  }));
};
export var FutureIconGlyph = function (props) {
  return React.createElement(FutureIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};